import { motion, useReducedMotion } from 'framer-motion';
import type { ReactNode } from 'react';

type Variant = 'default' | 'hero' | 'ai' | 'gold' | 'success' | 'train' | 'nutrition' | 'sleep';

const variantClass: Record<Variant, string> = {
  default: 'premium-card',
  hero: 'premium-card premium-card-hero',
  ai: 'premium-card premium-card-ai',
  gold: 'premium-card premium-card-gold',
  success: 'premium-card premium-card-success',
  train: 'premium-card premium-card-train',
  nutrition: 'premium-card premium-card-nutrition',
  sleep: 'premium-card premium-card-sleep',
};

export function PremiumCard({
  children,
  className = '',
  delay = 0,
  variant = 'default',
  onClick,
  id,
}: {
  children: ReactNode;
  className?: string;
  delay?: number;
  variant?: Variant;
  onClick?: () => void;
  id?: string;
}) {
  const reduceMotion = useReducedMotion();
  const Tag = onClick ? motion.button : motion.div;
  return (
    <Tag
      id={id}
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      initial={reduceMotion ? { opacity: 1, y: 0 } : { opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={
        reduceMotion ? { duration: 0 } : { duration: 0.4, ease: [0.25, 0.1, 0.25, 1], delay }
      }
      className={`card-interactive min-w-0 text-left ${variantClass[variant]} ${onClick ? 'w-full cursor-pointer' : ''} ${className}`}
    >
      {children}
    </Tag>
  );
}
